import QuestionSolidSVG from "@design-system/ui-icons/vanilla/QuestionSolid"
import { createIcon } from "../createIcon"

export const QuestionSolidIcon = createIcon(QuestionSolidSVG)
